module.exports = __webpack_public_path__ + "img/overview_image.d5d2db0a.svg";